'use strict';
const scrollWhenDragging = require('./scroll-when-dragging');
module.exports = function initialiseViewPortUIEvents(params, optional) {
	if (!params) {
		throw new Error('invalid-args');
	}
	const {viewPortDOM, mapModel, stage} = params,
		touchEnabled = (optional && optional.touchEnabled),
		centerSelectedNodeOnOrientationChange = (optional && optional.centerSelectedNodeOnOrientationChange);

	mapModel.addEventListener('inputEnabledChanged', function (canInput, holdFocus) {
		if (canInput && !holdFocus) {
			viewPortDOM.focus();
		}
	});

	if (!viewPortDOM || !mapModel ||  !stage) {
		throw new Error('invalid-args');
	}
	if (!touchEnabled) {
		scrollWhenDragging(viewPortDOM, mapModel.getInputEnabled); //no need to do this for touch, this is native;
		viewPortDOM.ownerDocument.addEventListener('mouseup', function () {
			if (viewPortDOM.style.overflow !== 'auto') {
				viewPortDOM.style.overflow = 'auto';
			}
		});
	}
	if (!touchEnabled) {
		window.addEventListener('resize', function () {
			mapModel.resetView();
		});
	}
	window.addEventListener('orientationchange', function () {
		if (centerSelectedNodeOnOrientationChange) {
			mapModel.centerOnNode(mapModel.getSelectedNodeId());
		} else {
			mapModel.resetView();
		}

	});
	['wheel', 'mousewheel'].forEach(event =>
		viewPortDOM.ownerDocument.addEventListener(event, (e) => {
			const scroll = e.deltaX || (-1 * e.wheelDeltaX);
			if (scroll < 0 && viewPortDOM.scrollLeft === 0) {
				e.preventDefault();
			}
			if (scroll > 0 && (viewPortDOM.scrollWidth - viewPortDOM.clientWidth - viewPortDOM.scrollLeft === 0)) {
				e.preventDefault();
			}
		}, {passive: false, capture: true})
	);
	viewPortDOM.focus();
};
